























































import {Component, Prop, Vue} from 'vue-property-decorator'
import HeaderBar from '@/components/HeaderBar.vue'
import MultipleDayOfWeek from '@/pages/SchedulePages/MultipleDayOfWeek.vue'
import DialogButtons from "@/components/Dialog/parts/DialogButtons.vue";
import TimePeriodSelector from "@/pages/SchedulePages/TimePeriodSelector.vue";
import DatePeriodSelector from "@/pages/SchedulePages/DatePeriodSelector.vue";
import DaySelector from "@/pages/SchedulePages/DaySelector.vue";
import {Util} from "@/_global/utils";
import {CmsApiUtil} from "@/_common/api/utils/cms_api_utils";

@Component({
    components: {
        DatePeriodSelector,
        TimePeriodSelector,
        HeaderBar,
        MultipleDayOfWeek,
        DialogButtons,
        DaySelector,
    },
})
export default class ScheduleEditor extends Vue {
    @Prop() private schedule!: CMS.Schedule;
    @Prop() private scheduleList!: CMS.Schedule[];
    @Prop() private selected!: string;

  get dayErrorMessage(): string {
    if (!CmsApiUtil.isDuplicateDay(this.schedule, this.scheduleList)) {
        return "同じ指定日、開始時刻が既に登録されています。";
    }

    return "";
  }

  get hasDayError(): boolean {
    return !!this.dayErrorMessage;
  }

  get dateErrorMessage(): string {
        if (!CmsApiUtil.isValidDatePeriod(this.schedule.start_date, this.schedule.end_date)) {
            return "終了日は開始日以降を指定してください。";
        }

        if (!CmsApiUtil.isDuplicatePeriod(this.schedule, this.scheduleList)) {
            return "同じ開始日、開始時刻が既に登録されています。";
        }

        return "";
    }

    get hasDateError(): boolean {
        return !!this.dateErrorMessage;
    }


    get timeErrorMessage(): string {
        if (this.selected == "period" && !CmsApiUtil.isDuplicatePeriod(this.schedule, this.scheduleList)) {
            return "同じ開始日、開始時刻が既に登録されています。";
        }

        if (this.selected == "day" && !CmsApiUtil.isDuplicateDay(this.schedule, this.scheduleList)) {
            return "同じ指定日、開始時刻が既に登録されています。";
        }

        return "";
    }

    get hasTimeError(): boolean {
        return !!this.timeErrorMessage;
    }


    private dateToUI(date: string): Date {
        return CmsApiUtil.dateToUI(date);
    }


    private timeToUI(time: string): Date {
        if (time === '') {
            return CmsApiUtil.dateToUI('');
        } else {
            return CmsApiUtil.timeToUI(time);
        }
    }

    private onDayChange(day: string) {
      const edited: CMS.Schedule = Util.deepCopy(this.schedule);
      edited.designated_date = day;
      this.$emit("change", edited);
    }

    private onDatePeriodChange(start: Date, end: Date) {
        const edited: CMS.Schedule = Util.deepCopy(this.schedule);
        edited.start_date = start === null || isNaN(+start) ? '' : CmsApiUtil.dateToDB(start);
        edited.end_date = end === null || isNaN(+end) ? '' : CmsApiUtil.dateToDB(end);
        this.$emit("change", edited);
    }

    private onTimePeriodChange(start: Date, end: Date) {
        const edited: CMS.Schedule = Util.deepCopy(this.schedule);
        edited.start_time = start === null || isNaN(+start) ? '' : CmsApiUtil.timeToDB(start);
        edited.end_time = end === null || isNaN(+end) ? '' : CmsApiUtil.timeToDB(end);
        this.$emit("change", edited);
    }

    private onDaysOfWeekChange(daysOfWeek: number[]) {
        const edited: CMS.Schedule = Util.deepCopy(this.schedule);
        edited.weeks = daysOfWeek;
        this.$emit("change", edited);
    }
}
